import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { logError, reactPlugin } from './AppInsights';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { Provider } from 'react-redux';
import store, { persistor } from '@/state/index';
import { PersistGate } from 'redux-persist/integration/react';
import { ERROR_MESSSAGES } from '@constants/common.constants';
import ErrorComponent from '@components/Error';
import ServiceDownImg from '@assets/images/error/service-down.svg';
import { getMsalInstance } from '@auth/msalInstance';

const root = ReactDOM.createRoot(document.getElementById('root')!);

getMsalInstance()
	.then((msalInstance) => {
		root.render(
			<React.StrictMode>
				<Provider store={store}>
					<PersistGate loading={null} persistor={persistor}>
						<AppInsightsErrorBoundary
							onError={() => (
								<ErrorComponent
									img={<ServiceDownImg width='100%' height='100%' />}
									title={ERROR_MESSSAGES.SERVICE_DOWN.TITLE}
									description={
										<>
											<p>{ERROR_MESSSAGES.SERVICE_DOWN.DESCRIPTION}</p>
											<p className='mt-6 tablet:mt-0'>{ERROR_MESSSAGES.SERVICE_DOWN.SUB_DESCRIPTION}</p>
										</>
									}
									btnText={ERROR_MESSSAGES.SERVICE_DOWN.BTN_TEXT}
									btnCallback={() => window.location.reload()}
								/>
							)}
							appInsights={reactPlugin}>
							<App msalInstance={msalInstance} />
						</AppInsightsErrorBoundary>
					</PersistGate>
				</Provider>
			</React.StrictMode>,
		);
	})
	.catch((error) => {
		logError(new Error('MSAL initialization failed', error));
		root.render(
			<ErrorComponent
				img={<ServiceDownImg width='100%' height='100%' />}
				title={ERROR_MESSSAGES.SERVICE_DOWN.TITLE}
				description={
					<>
						<p>{ERROR_MESSSAGES.SERVICE_DOWN.DESCRIPTION}</p>
						<p className='mt-6 tablet:mt-0'>{ERROR_MESSSAGES.SERVICE_DOWN.SUB_DESCRIPTION}</p>
					</>
				}
				btnText={ERROR_MESSSAGES.SERVICE_DOWN.BTN_TEXT}
				btnCallback={() => window.location.reload()}
			/>,
		);
	});
